import { Layout } from "../../layouts/authLayout/Layout.js";
import Signup from "../../components/auth/Signup.js"
 const SignupPage = () => {
  return (
    <Layout>
      <Signup/>
    </Layout>
  )
}
export default SignupPage